import { useState } from "react";
import { FaEdit } from "react-icons/fa";

const CustomerAddress = () => {
  const [isEditing, setIsEditing] = useState(false);
  
  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div className="w-full py-2">
      <div className="text-xs"> {/* Added text-sm */}
        <div className="flex items-center justify-between mb-2 border-b border-gray-400 pb-2"> {/* Smaller margin/padding */}
          <div className="flex items-center space-x-1">
            <h2 className="text-sm font-semibold">Address Details</h2> {/* Smaller text */}
            <FaEdit className="cursor-pointer text-gray-500 text-xs" onClick={toggleEdit} /> {/* Smaller icon */}
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 p-1"> {/* Smaller gap */}
          {fields.map(({ label, value }, index) => (
            <div key={index} className="py-2">
              <label className="block text-[10px] font-medium text-gray-600">{label}</label> {/* Smaller label */}
              <input 
                type="text" 
                defaultValue={value} 
                disabled={!isEditing} 
                className={`w-full p-2 mt-0.5 rounded-md text-xs ${isEditing ? "border border-gray-300" : "border-none"}`} 
              />
            </div>
          ))}
        </div>
        
        {isEditing && (
          <div className="flex justify-end mt-2">
            <button className="px-2 py-1 bg-blue-500 text-white rounded-md mr-1 text-[10px]" onClick={toggleEdit}>Cancel</button>
            <button className="px-2 py-1 bg-blue-500 text-white rounded-md text-[10px]">Save Changes</button>
          </div>
        )}
      </div>
    </div>
  );
};

const fields = [
  { label: "Address 1", value: "Tirunelveli" },
  { label: "Address 2", value: "Tirunelveli" },
  { label: "District", value: "Tirunelveli" },
  { label: "Taluk", value: "Tirunelveli" },
  { label: "Village", value: "Tirunelveli" },
  { label: "PostCode", value: "624001" }
];

export default CustomerAddress;
